<template>
  <div>
    <v-skeleton-loader type="table-tbody" v-if="$store.state.loading"></v-skeleton-loader>
    <v-table class="result_table" density="compact" v-else style="border-radius: 5px">
      <thead class="bg-secondary">
        <tr>
          <th>Clt</th>
          <th>Nom - Prénom</th>
          <th>Doss.</th>

          <th>Clt Cat</th>
          <th>Clt Sexe</th>
          <th>Temps</th>
          <th>Club</th>
        </tr>
      </thead>
      <tbody v-if="filteredRunners.length > 0">
        <tr v-for="(runner, id_runner) in filteredRunners" :key="id_runner">
          <td>
            <b>{{ runner.classement }}</b>
          </td>
          <td>
            <b>{{ runner.nom }} {{ runner.prenom }}</b>
          </td>
          <td>{{ runner.dossard }}</td>

          <td>{{ runner.classement_categorie }}</td>
          <td>{{ runner.classement_sexe }}</td>
          <td>
            <b class="text-accent" style="font-size: 1.1rem">{{ runner.temps }}</b>
          </td>
          <td>{{ runner.club }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="7" v-if="filters.challenge != 'Tous' || filters.sexe != 'Tous' || filters.search != ''" class="text-center">Aucun participant ne correspond à votre recherche</td>
          <td colspan="7" v-else class="text-center">En attente des résultats</td>
        </tr>
      </tbody></v-table
    >
  </div>
</template>

<script>
export default {
  props: ["loop", "filters"],
  computed: {
    filteredRunners() {
      if (!this.loop) return [];
      let runners = this.loop.runners;
      if (this.$store.state.selected_challenge) {
        runners = runners.filter((runner) => {
          return runner.course === this.$store.getters.get_challenge_name;
        });
      }
      if (this.filters.challenge != "Tous") {
        runners = runners.filter((runner) => {
          return runner.course === this.filters.challenge;
        });
      }
      if (this.filters.sexe != "Tous") {
        runners = runners.filter((runner) => {
          return runner.sexe === this.filters.sexe;
        });
      }
      if (this.filters.search != "") {
        runners = runners.filter((runner) => {
          return runner.nom.toLowerCase().includes(this.filters.search.toLowerCase()) || runner.prenom.toLowerCase().includes(this.filters.search.toLowerCase());
        });
      }

      return runners;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>